var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 125,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.871 113.866v.014l.001.014c.152 5.477-4.424 10.095-10.123 10.095H11.134c-5.674 0-10.123-4.598-10.123-10.123V11.134C1.011 5.46 5.61 1.01 11.134 1.01h134.615c5.673 0 10.122 4.598 10.122 10.123v102.732Z",
    fill: "#F9FAFB",
    stroke: "#F3F4F6",
    strokeWidth: 2.022
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.368 44.477H53.305v50.082h49.063V44.477Z",
    stroke: "#EAEFEB",
    strokeWidth: 4.045,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.554 39.718h7.5c.558 0 1.01.453 1.01 1.011v7.5c0 .558-.452 1.011-1.01 1.011h-7.5a1.011 1.011 0 0 1-1.012-1.011v-7.5c0-.558.453-1.01 1.012-1.01ZM98.612 39.718h7.5c.558 0 1.011.453 1.011 1.011v7.5c0 .558-.453 1.011-1.011 1.011h-7.5a1.011 1.011 0 0 1-1.01-1.011v-7.5c0-.558.452-1.01 1.01-1.01ZM49.554 89.632h7.5c.558 0 1.01.453 1.01 1.011v7.5c0 .558-.452 1.011-1.01 1.011h-7.5a1.011 1.011 0 0 1-1.012-1.011v-7.5c0-.558.453-1.01 1.012-1.01Z",
    fill: "#BAC7BB",
    stroke: "#EAEFEB",
    strokeWidth: 2.022
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.306 81.095a1.011 1.011 0 0 1 1.277-1.28l19.25 6.377c.852.283.941 1.453.142 1.86l-1.221.624a3.034 3.034 0 0 0-.788 4.825l4.823 4.923c.388.396.385 1.031-.007 1.423l-3.096 3.097a1.013 1.013 0 0 1-1.43 0l-4.712-4.712a3.034 3.034 0 0 0-4.751.593l-1.164 1.953c-.443.743-1.554.623-1.828-.198l-6.495-19.485Z",
    fill: "url(#a)",
    fillOpacity: 0.5,
    stroke: "#EAEFEB",
    strokeWidth: 2.022
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 99.994,
    y1: 78.541,
    x2: 99.994,
    y2: 93.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CCB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AE96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorate);
export default __webpack_public_path__ + "static/media/norate.a719a4ef503254f748399ce03fffda79.svg";
export { ForwardRef as ReactComponent };